import { AppDate } from '../envTypes';

import { ModelBase } from './base';
import { CaptureGroupStatus } from './order';

// CaptureGroupStatus is exported from ./order

export interface BaseCaptureGroup extends ModelBase {
  buyerId: string;
  paymentMethodId: string;
  total: number;
  fingerprint: string;
  sellerId?: string;
  /**
   * remove on next version from 2023-08-15, equal to pslGotAmount
   */
  totalApplicationFeeAmount?: number;
  profitBreakdown?: {
    /**
     * Psl get the sum of the amount from the capture group
     */
    pslGotAmount: number;
    dropshipping?: {
      /**
       * Creator get the sum of the amount from the capture group
       */
      creatorGotAmount: number;
      /**
       * DS Management get the sum of the amount from the capture group
       */
      partnerGotAmount: number;
    };
  };
  /**
   * records of dropshipping transactions, included creator income transaction
   */
  dropshippingTransactions?: {
    creatorTransaction: {
      amount: number;
      updatedAt: AppDate;
    };
  };
}

export interface RequirePaymentCaptureGroup extends BaseCaptureGroup {
  status: CaptureGroupStatus.RequiresPayment;
  closed: false;
}

export interface RequiredCaptureCaptureGroup extends BaseCaptureGroup {
  paymentIntentId: string;
  status: CaptureGroupStatus.RequiresCapture;
  closed: boolean;
  authorizedAmount: number;
}

export interface CapturedCaptureGroup extends BaseCaptureGroup {
  paymentIntentId: string;
  status: CaptureGroupStatus.Captured;
  closed: true;
  capturedAmount: number;
  refundAmount: number;
  authorizedAmount: number;
}

export interface CanceledCaptureGroup extends BaseCaptureGroup {
  status: CaptureGroupStatus.Canceled;
  paymentIntentId: string;
  closed: true;
  authorizedAmount: number;
}

export interface FailedCaptureGroup extends BaseCaptureGroup {
  status: CaptureGroupStatus.Failed;
  paymentIntentId: string;
  closed: true;
  authorizedAmount: number;
  capturedAmount: 0;
}

export type CaptureGroup =
  | RequirePaymentCaptureGroup
  | RequiredCaptureCaptureGroup
  | CapturedCaptureGroup
  | CanceledCaptureGroup
  | FailedCaptureGroup;

export enum ChangeRecordType {
  CreateOrder = 'createOrder',
  CreateOrderRevert = 'createOrderRevert',
  RefundOrder = 'refundOrder',
  RefundOrderRevert = 'refundOrderRevert',
}

export interface CaptureGroupChangeRecord extends ModelBase {
  orderId: string;
  amount: number;
  type: ChangeRecordType;
}
